import { render } from "./Testimonial.vue?vue&type=template&id=4edc8f18&ts=true"
import script from "./Testimonial.vue?vue&type=script&lang=ts"
export * from "./Testimonial.vue?vue&type=script&lang=ts"

import "./Testimonial.vue?vue&type=style&index=0&id=4edc8f18&lang=scss"

import exportComponent from "/home/runner/work/digital-creative-website/digital-creative-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__